<template>
    <f7-page name="company-videos">
        <bc-navbar></bc-navbar>
        <br/>
        <div style="-webkit-touch-callout: none; height: 100%; overflow-y: scroll; width: 100%;">
            <div v-if="isRequestActive" class="loader"> 
                <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" :color="customization.mainColor" />
            </div>
            <div class="layout_fullwidth_padding" v-if="!isRequestActive">
                <h3>Company Videos</h3>
                <div class="company-video" style="text-align:center">
                    <youtube  v-for="(video,key) in videos" :player-vars="playerVars" :video-id="video.youtubeKey" :key="key" width="100%" >            
                    </youtube>
                </div>                
            </div>          
        </div>
    </f7-page>
</template>

<script>
import { mapState } from 'vuex'
import { LoopingRhombusesSpinner } from 'epic-spinners'

export default {
  components: {
    LoopingRhombusesSpinner
  },
  mounted: function () {
    this.$store.dispatch('aboutCompany/loadCompanyVideo')
            .then(() => {
              this.isRequestActive = false
            }).catch(x => {
              this.$f7.mainView.router.load({url: 'error'})
            })
  },
  updated: function () {
  },
  computed: {
    ...mapState({
      videos: state => state.aboutCompany.companyVideo,
      customization: state => state.common.customization
    })
  },
  methods: {
  },
  data () {
    return {
      isRequestActive: true,
      playerVars: {
        autoplay: 0,
        width: '100%',
        height: 'auto'
      }
    }
  }
}
</script>
<style>
.company-video iframe { 
  width: 100% !important; 
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// company-video.vue?51080394